import { Console } from "console";

export class Utils {
  static stringToDate(val: string) {
    const parts = val.toString().split("-");
    const dt = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    dt.setHours(12);
    dt.setMinutes(13);
    dt.setSeconds(14);
    return dt;
  }

  static formatarData(data: Date): string {
    if (!(data instanceof Date)) {
      // Convert the selected date to a valid Date instance
      const convertedDate = new Date(data);
      if (isNaN(convertedDate.getTime())) {
        throw new Error(
          "O argumento fornecido não é uma instância de Date e não foipossivel fazer a conversao"
        );
      }
      data = convertedDate;
    }

    const dia = data.getDate().toString().padStart(2, "0");
    const mes = (data.getMonth() + 1).toString().padStart(2, "0"); // getMonth() retorna mês de 0 a 11
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  static truncate(source, size) {
    return source?.length > size ? source?.slice(0, size - 1) + "…" : source;
  }

  static convertToCpfCnpj(num) {
    if (num) {
      num = num.toString();
      num = num.replace(/\D/g, "");

      switch (num.length) {
        case 4:
          num = num.replace(/(\d+)(\d{3})/, " $1.$2");
          break;
        case 5:
          num = num.replace(/(\d+)(\d{3})/, " $1.$2");
          break;
        case 6:
          num = num.replace(/(\d+)(\d{3})/, " $1.$2");
          break;
        case 7:
          num = num.replace(/(\d+)(\d{3})(\d{3})/, " $1.$2.$3");
          break;
        case 8:
          num = num.replace(/(\d+)(\d{3})(\d{3})/, " $1.$2.$3");
          break;
        case 9:
          num = num.replace(/(\d+)(\d{3})(\d{3})/, " $1.$2.$3");
          break;
        case 10:
          num = num.replace(/(\d+)(\d{3})(\d{3})(\d{1})/, " $1.$2.$3-$4");
          break;
        case 11:
          num = num.replace(/(\d+)(\d{3})(\d{3})(\d{2})/, " $1.$2.$3-$4");
          break;
        case 12:
          num = num.replace(/(\d+)(\d{3})(\d{3})(\d{4})/, " $1.$2.$3/$4");
          break;
        case 13:
          num = num.replace(
            /(\d+)(\d{3})(\d{3})(\d{4})(\d{2})/,
            " $1.$2.$3/$4-$5"
          );
          break;
        case 14:
          num = num.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d+)/,
            " $1.$2.$3/$4-$5"
          );
          break;
      }
    }
    return num;
  }

  /**
   * Format bytes as human-readable text.
   *
   * @param bytes Number of bytes.
   * @param si True to use metric (SI) units, aka powers of 1000. False to use
   *           binary (IEC), aka powers of 1024.
   * @param dp Number of decimal places to display.
   *
   * @return Formatted string.
   */
  static humanFileSize(bytes, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
      return bytes + " B";
    }

    const units = si
      ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
    let u = -1;
    const r = 10 ** dp;

    do {
      bytes /= thresh;
      ++u;
    } while (
      Math.round(Math.abs(bytes) * r) / r >= thresh &&
      u < units.length - 1
    );

    return bytes.toFixed(dp) + " " + units[u];
  }

  static abreviar(razaoSocial: string, maxLength: number = 60): string {
    if (!razaoSocial) return '';

    // Verifica se a razão social já está dentro do limite
    if (razaoSocial.length <= maxLength) {
      return razaoSocial;
    }

    // Lista de palavras comuns a serem removidas
    const palavrasComuns = [
      'EIRELI', 'MEI'
    ];

    // Mapeamento de palavras a serem abreviadas
    const abreviacoes: { [key: string]: string } = {
      INDUSTRIAL: "INDIAL",
      INDUSTRIA: "IND.",
      INDÚSTRIA: "IND.",
      COMERCIAL: "CIAL",
      COMERCIO: "COM.",
      SERVICOS: "SERV.",
      EMPRESA: "EMP.",
      SOCIEDADE: "SOC.",
      LIMITADA: "LTDA",
      ANONIMA: "ANON.",
      CONSTRUCOES: "CONST.",
      TECNOLOGIA: "TEC.",
      CONSULTORIA: "CONS.",
      ENGENHARIA: "ENG.",
      IMPORTACAO: "IMP.",
      EXPORTACAO: "EXP.",
      DISTRIBUIDORA: "DIST.",
      TRANSPORTADORA: "TRANSP.",
      FABRICACAO: "FAB.",
      MANUTENCAO: "MANUT.",
      ADMINISTRACAO: "ADM.",
      LOGISTICA: "LOG.",
      INTERNACIONAL: "INT.",
      INTERNACIONALIZACAO: "INT.",
      INTERNACIONALIZADA: "INT.",
      INTERNACIONALIZADO: "INT.",
      CLINICA: "CLIN.",
      HOSPITAL: "HOSP.",
      HOSPITALAR: "HOSP.",
      EDUCACIONAL: "EDU.",
      ESCOLA: "ESC.",
      FACULDADE: "FCL.",
      UNIVERSIDADE: "UNIV.",
      ASSOCIACAO: "ASSOC.",
      ORGANIZACAO: "ORG.",
      INSTITUTO: "INST.",
      FUNDACAO: "FUND.",
      AGROPECUARIA: "AGRO.",
      AGROINDUSTRIAL: "AGROIND.",
      HEMODIALISE: "HEMO."
    };

    // Normaliza o texto: remove acentos, converte para maiúsculas
    let texto = razaoSocial
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove acentos
      .toUpperCase()
      .trim();

    // Aplica abreviações específicas
    for (const [original, abreviada] of Object.entries(abreviacoes)) {
      const regex = new RegExp(`\\b${original}\\b`, 'gi');
      texto = texto.replace(regex, abreviada);
    }

    // Remove palavras comuns
    palavrasComuns.forEach(palavra => {
      const regex = new RegExp(`\\b${palavra}\\b`, 'gi');
      texto = texto.replace(regex, '').replace(/\s+/g, ' ').trim();
    });

    console.log(`Texto normalizado: ${texto}`);

    // Divide o texto em palavras
    const palavras = texto.split(' ').filter(p => p.length > 0);

    console.log(`Palavras após normalização: ${palavras}`);

    // Se o texto já é curto o suficiente, retorna como está
    if (texto.length <= maxLength) {
      return palavras.join(' ');
    }

    console.log(`Texto original: ${razaoSocial}`);
    console.log(`Texto abreviado: ${texto}`);


    // Abreviar mantendo primeiras palavras e iniciais
    let resultado = '';
    let palavrasUsadas = 0;

    for (let i = 0; i < palavras.length; i++) {
      const palavra = palavras[i];
      // Mantém as primeiras palavras inteiras enquanto couber
      if (resultado.length + palavra.length <= maxLength - 3) {
        resultado += (resultado ? ' ' : '') + palavra;
        palavrasUsadas++;
      } else {
        // Para as palavras restantes, usa apenas a inicial
        for (let j = palavrasUsadas; j < palavras.length; j++) {
          if (palavras[j].length > 0) {
            resultado += palavras[j][0] + '.';
          }
        }
        break;
      }
    }

    console.log(`Resultado abreviado: ${resultado}`);
    // Remove espaços extras no início e no final
    resultado = resultado.trim();

    // Garante que não ultrapasse o maxLength
    return resultado.length > maxLength 
      ? resultado.substring(0, maxLength - 3) + '...' 
      : resultado;
  }
}
